<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="acknowledgement">
<h1>Acknowledgement</h1>
<p>I should like to thank: Dave Freeman, an inspirational English teacher whose passion for literature has remained with me throughout my teaching career; John Thomason, a true gentleman who first encouraged me to offer classroom management training; Bob Isaac with whom I have worked collaboratively and creatively for over thirty years and whose stories of classroom management faux pas have made me laugh until my sides ached; Maggie McMurray, colleague and friend with whom I have shared numerous cups of Earl Grey tea whilst we have watched, amazed, at the machinations and ineptitudes of some aspects of the educational system; Jill Eatherden, colleague and friend with whom I joint-taught probably the worst lesson of both of our lives; Liz, my wife who has loved and supported me throughout my career and our sons, Chris and Alex, without whom all of this would be dust.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch005.vue?826ecb9a